export default __webpack_public_path__ + "static/media/backgroundmobile.ca375147.png";